import axios from 'axios';
import { apiUrl } from '../store/createStore';

const SID_GET_NAME_ENDPOINT = '/wallet-info/sid/name';
const BNB_TLD = 'bnb';
const ARB_TLD = 'arb1';

const getBnbName = async (address: string): Promise<string | null> => {
  try {
    const url =
      apiUrl +
      SID_GET_NAME_ENDPOINT +
      '?tld=' +
      BNB_TLD +
      '&address=' +
      address;
    const resp = await axios(url);
    const data = JSON.parse(resp.data);
    return data.name || null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

const getArbName = async (address: string): Promise<string | null> => {
  try {
    const url =
      apiUrl +
      SID_GET_NAME_ENDPOINT +
      '?tld=' +
      ARB_TLD +
      '&address=' +
      address;
    const resp = await axios(url);
    const data = JSON.parse(resp.data);
    return data.name || null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

const getSidWalletName = async (address: string, isArb: boolean) => {
  if (isArb) {
    const arbName = await getArbName(address);
    if (arbName) {
      return arbName;
    } else {
      return await getBnbName(address);
    }
  }

  const bnbName = await getBnbName(address);
  if (bnbName) {
    return bnbName;
  }
  return await getArbName(address);
};

export { getArbName, getBnbName, getSidWalletName };
